import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PracticeWorkingHour } from '@/types/settings-api';

/**
 * Fetch the working-hours profiles for a practice (PROD-758).
 *   GET /api/Practice/WorkingHoursList/{practiceSetupId}
 *
 * Flutter parity: `fetchPracticeWorkingHoursList` /
 * `practice_working_hours_list_model.dart`.
 *
 * The response is `PracticeWorkingHour[]` — one entry per profile. Each
 * profile contains a `workingHoursRequest[]` of 7 per-day slots
 * (Mon-Sun), with the per-slot hour/minute strings in the human-readable
 * format the cURL revealed: `"04 AM"`, `"00 min"`, `"11 PM"`, etc.
 * NOT 24h numeric.
 */
export function useWorkingHoursList(
  practiceSetupId: string | null | undefined,
) {
  return useQuery({
    queryKey: ['settings', 'working-hours-list', practiceSetupId],
    queryFn: ({ signal }) => {
      if (!practiceSetupId) {
        throw new Error('useWorkingHoursList called without practiceSetupId');
      }
      return get<PracticeWorkingHour[]>(
        `/api/Practice/WorkingHoursList/${practiceSetupId}`,
        { signal },
      );
    },
    enabled: !!practiceSetupId,
  });
}
